module.exports = __webpack_public_path__ + "fonts/nucleo-icons.eot!static";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nucleo-icons.eot
// module id = 26
// module chunks = 0